import {ErrorCode} from '../../app/types';
import {Error0028} from './components/error/Error0028';
import {ErrorComponent} from './type';

export const errorComponents: {[key in ErrorCode]: ErrorComponent} = {
  '0028': Error0028,
};
